export default __webpack_public_path__ + "static/Danishia Davis-3f8af0e4ba71f449a852d42cb2468778.jpg";